import { Button, Checkbox, Container, Image, InputNumber, Label, Modal, Radio } from 'app/components';
import { SectionEntities } from 'app/components/Entity';
import { useConfig, useModal } from 'app/hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { MainSection, SelectionHeadingSelection, SelectionItemSelection, SelectionSelection, SubSection, SubSection1, SubSection2, ButtonSection, SelectionMobileBoxMenu } from './styles';
import { RowButton } from '../styles';
import CrossIcon from '../../../assets/images/close.png';
import { MainSectionMobileView } from './styles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const BoxMenu = ({ fetchComboItem, comboId, setConcessionData,
  notify, remove, languageContentsForPopup, languageContents, isModalOpen, windowSizes, setIsModalOpen, setConcessionComboItem }) => {
  const {
    api: { endpoint },
    currencyForCountry
  } = useConfig();
  const modal = useSelector(state => state.layout.modals['BoxMenu']);
  const [t, i18n] = useTranslation();

  const { language } = i18n;

  const [BoxMenu, showBoxMenu, hideBoxMenu] = useModal('BoxMenu');
  const [windowSize, setWindowSize] = useState();
  const [summeDetails, setSummeDetails] = useState(false);
  const [isExpanded, toggleExpand] = useState(false);
  const comboItemData = useSelector(state => state?.concessions?.comboItemData);

  // New Data added
  const [selectedDrink, setSelectedDrink] = useState(null);  // New state to track selected drink
  const [showPfand, setShowPfand] = useState(false);  // New state to toggle Pfand section


  const [selectedItems, setSelectedItems] = useState({});
  const selectedItemsData = useSelector(state => state?.concessions?.concessionData);
  const [selectedArrayItems, setSelectedArrayItems] = useState([]);
  const [disableAddBtn, setDisableAddBtn] = useState(false);
  const toastersId = useSelector(state => state.layout.toasters);
  const [maxQuantity, setMaxQuantity] = useState(0);

  const isClearingRef = React.useRef(false);

  const handleSummeDetail = (item, id) => {
    const session = 'comboSession';
    const updatedItems = {
      normalSession: { ...selectedItemsData.normalSession },
      comboSession: { ...selectedItemsData.comboSession }
    };

    const childItems = selectedItemsData?.comboSession?.[comboId?.itemId]?.packageChildItems || [];

    const maxQuantity = childItems.reduce((max, currentItem) => {
      return Math.max(max, currentItem.quantity || 1);
    }, 1);

    if (selectedItemsData && comboId && selectedItemsData['comboSession'][comboId?.itemId]?.packageChildItems?.length === 0) {
      delete updatedItems['comboSession'][comboId?.itemId];
    } else {
      updatedItems[session][id] = {
        ...item.comboSession[id],
        quantity: maxQuantity,
      };
    }
    setConcessionData(updatedItems);
    toggleExpand(!isExpanded);
    setSummeDetails(!summeDetails);
    remove(toastersId[0]?.id);
    setConcessionComboItem([]);
    setIsModalOpen(!isModalOpen);
  };

  const handleCheckboxChange = (itemIdx, description, altItem, quantity) => {
    setSelectedItems(prevSelectedItems => {
      const updatedSelectedItems = { ...prevSelectedItems };
      if (!updatedSelectedItems[description]) {
        updatedSelectedItems[description] = [];
      }

      const isSelected = updatedSelectedItems[description].some(item => item.ItemId === altItem.Id);
      const selectedCount = updatedSelectedItems[description].length;
      if (isSelected) {
        updatedSelectedItems[description] = updatedSelectedItems[description].filter(item => item.ItemId !== altItem.Id);
      } else if (selectedCount < quantity) {

        // Construct the new item object
        const newItem = {
          ItemId: altItem.Id,
          quantity: 1,
          ParentSaleItem: { ItemId: itemIdx },
        };
        // Add Modifiers only if ModifierGroups exist
        if (altItem?.ModifierGroups?.length > 0) {
          newItem.Modifiers = [
            {
              ModifierItemId: altItem.ModifierGroups[0]?.Modifiers[0]?.Id,
              Quantity: 1,
              ModifierGroupId: altItem.ModifierGroups[0]?.Id
            }
          ];
        }
        updatedSelectedItems[description] = [...updatedSelectedItems[description], newItem];

        // updatedSelectedItems[description] = [
        //   ...updatedSelectedItems[description],
        //   {
        //     ItemId: altItem.Id,
        //     // Description: altItem.Description,
        //     quantity: 1,
        //     ParentSaleItem: {
        //       ItemId: itemIdx
        //     },
        //     Modifiers: [
        //       {
        //         ModifierItemId: altItem?.ModifierGroups[0]?.Modifiers[0]?.Id,
        //         Quantity: 1,
        //         ModifierGroupId: altItem?.ModifierGroups[0]?.Id
        //       }
        //     ]
        //   }
        // ];

      } else {
        const newItem = {
          ItemId: altItem.Id,
          quantity: 1,
          ParentSaleItem: { ItemId: itemIdx },
        };
        // Add Modifiers only if ModifierGroups exist
        if (altItem?.ModifierGroups?.length > 0) {
          newItem.Modifiers = [
            {
              ModifierItemId: altItem.ModifierGroups[0]?.Modifiers[0]?.Id,
              Quantity: 1,
              ModifierGroupId: altItem.ModifierGroups[0]?.Id
            }
          ];
        }
        updatedSelectedItems[description] = [
          ...updatedSelectedItems[description].slice(1),
          newItem
          // {
          //   ItemId: altItem.Id,
          //   // Description: altItem.Description,
          //   quantity: 1,
          //   ParentSaleItem: {
          //     ItemId: itemIdx
          //   }
          // }
        ];
      }

      // 🔍 Check if any selected items still have ModifierGroups
      const stillHasPfand = Object.values(updatedSelectedItems).flat().some(item => {
        const match = comboItemData
          ?.flatMap(ci => ci?.alternateItems || [])
          ?.find(alt => alt.Id === item.ItemId);
        return match?.ModifierGroups?.length > 0;
      });
      setSelectedDrink(
        stillHasPfand
          ? comboItemData
            .flatMap(ci => ci?.alternateItems || [])
            .find(alt => alt.Id === altItem.Id)?.ModifierGroups || []
          : []
      );
      setShowPfand(stillHasPfand);
      return updatedSelectedItems;
    });
  };

  const handleQuantityChange = (itemIdx, description, altItem, newQuantity, maxQuantity) => {
    const totalSelectedQuantity = selectedItems[description]?.reduce((sum, item) => sum + item.quantity, 0) || 0;

    const existingItemQuantity = selectedItems[description]?.find(item => item.ItemId === altItem.Id)?.quantity || 0;
    if (totalSelectedQuantity - existingItemQuantity + newQuantity > maxQuantity) {
      onMaxNotify();
      return;
    }

    setSelectedItems(prevSelectedItems => {
      const updatedSelectedItems = { ...prevSelectedItems };

      if (!updatedSelectedItems[description]) {
        updatedSelectedItems[description] = [];
      }

      const existingItemIndex = updatedSelectedItems[description].findIndex(item => item.ItemId === altItem.Id);

      if (newQuantity === 0) {
        updatedSelectedItems[description] = updatedSelectedItems[description].filter(item => item.ItemId !== altItem.Id);
      } else if (existingItemIndex !== -1) {
        updatedSelectedItems[description][existingItemIndex].quantity = newQuantity;
      } else {
        updatedSelectedItems[description].push({
          ItemId: altItem.Id,
          quantity: newQuantity,
          ParentSaleItem: {
            ItemId: itemIdx
          }
        });
      }

      return updatedSelectedItems;
    });
  };

  const handleDirectSelection = (item) => {
    const itemData = selectedItemsData.comboSession[comboId?.itemId];
    if (!item || item.length === 0 || !itemData) return;
    const { id, description } = item;
    if (comboId?.itemId === itemData?.id) {
      setSelectedItems((prevSelectedItems) => {
        const updatedSelectedItems = { ...prevSelectedItems };

        if (!updatedSelectedItems[description]) {
          updatedSelectedItems[description] = [];
        }

        const existingIndex = updatedSelectedItems[description].findIndex(i => i.ItemId === id);
        if (existingIndex !== -1) {
          updatedSelectedItems[description][existingIndex].quantity = item.quantity || 1;
        } else {
          updatedSelectedItems[description].push({
            ItemId: id,
            quantity: item.quantity || 1
          });
        }

        return updatedSelectedItems;
      });
    }
  };

  useEffect(() => {
    const concessionData = Object.values(selectedItems).flat();
    if (concessionData.length > 0) {
      setSelectedArrayItems(concessionData);
    } else {
      setSelectedArrayItems([]);
    }

    const totalQuantityComboItems = comboItemData?.reduce((sum, item) => sum + item?.quantity, 0);

    const updatedSelectedItems = { ...(selectedItems || {}) };
    (comboItemData || []).forEach(({ id, description, quantity, alternateItems }) => {
      if (
        !updatedSelectedItems[description]?.some(i => i.ItemId === id) &&
        (!alternateItems || alternateItems.length === 0)
      ) {
        updatedSelectedItems[description] = [
          ...(updatedSelectedItems[description] || []),
          { ItemId: id, quantity }
        ];
      }
    });

    let totalQuantitySelectedItems = Object.keys(updatedSelectedItems).reduce((total, key) => {
      return total + updatedSelectedItems[key]?.reduce((sum, item) => sum + item?.quantity, 0);
    }, 0);

    if (totalQuantityComboItems === totalQuantitySelectedItems) {
      setDisableAddBtn(false);
    }
    else {
      setDisableAddBtn(true);
    }
  }, [selectedItems, comboItemData]);

  const updateItemQuantity = (item, description) => (newQuantity) => {
    const session = 'comboSession';
    const updatedItems = {
      normalSession: { ...item.normalSession },
      comboSession: { ...item.comboSession }
    };
    if (newQuantity === 0) {
      delete updatedItems[session][description];
    } else {
      updatedItems[session][description] = {
        ...item.comboSession[description],
        quantity: newQuantity,
      };
    }
    setConcessionData(updatedItems);
  };

  const handleClearComboData = (item, id) => {
    isClearingRef.current = true;
    const session = 'comboSession';
    const updatedItems = {
      normalSession: { ...selectedItemsData.normalSession },
      comboSession: { ...selectedItemsData.comboSession }
    };

    const childItems = selectedItemsData?.comboSession?.[comboId?.itemId]?.packageChildItems || [];


    const maxQuantity = childItems.reduce((max, currentItem) => {
      return Math.max(max, currentItem.quantity || 1);
    }, 1);


    if (selectedItemsData && comboId && selectedItemsData['comboSession'][comboId?.itemId]?.packageChildItems?.length === 0) {
      delete updatedItems['comboSession'][comboId?.itemId];
    } else {
      updatedItems[session][id] = {
        ...item.comboSession[id],
        quantity: maxQuantity,
      };
    }
    setConcessionComboItem(null);
    setSelectedItems({});
    setConcessionData(updatedItems);
    setIsModalOpen(!isModalOpen);
    remove(toastersId[0]?.id);
    setConcessionComboItem([]);
  }

  const handleAddComboData = () => {
    if (!selectedItemsData.comboSession) {
      selectedItemsData.comboSession = {};
    }

    const finalPayloadItems = [];
    Object.values(selectedItemsData.comboSession).forEach(item => {
      if (item.id === comboId?.itemId) {
        const newItem = {
          itemId: item.id,
          cinemaId: item.cinemaId,
          quantity: 1,
          packageChildItems: selectedArrayItems,
        };
        // 🔍 Check if any item in packageChildItems has Modifiers
        const itemHasModifiers = selectedArrayItems.some(child => child?.Modifiers?.length > 0);
        if (itemHasModifiers) {
          const modifierGroups = [];

          // Loop through all child items to gather relevant ModifierGroups from comboItemData
          selectedArrayItems.forEach(child => {
            const matchingComboItem = comboItemData.find(combo =>
              combo.alternateItems?.some(alt => alt.Id === child.ItemId)
            );

            const matchedAltItem = matchingComboItem?.alternateItems?.find(alt => alt.Id === child.ItemId);

            if (matchedAltItem?.ModifierGroups?.length > 0) {
              modifierGroups.push(...matchedAltItem.ModifierGroups);
            }
          });

          const existingAlternates = selectedItemsData.comboSession[comboId?.itemId]["alternateItems"] || [];
          const mergedMap = {};

          // Add existing items to the map
          existingAlternates.forEach(item => {
            mergedMap[item.Id] = { ...item, quantity: item.quantity || 1 };
          });
          // // Ensure no duplicates by unique ModifierGroup Ids
          let uniqueModifierGroups = Array.from(
            new Map(modifierGroups.map(mg => [mg.Id, mg])).values()
          );
          // let uniqueModifierGroups;
          // Add or update incoming modifier groups
          uniqueModifierGroups.forEach(newItem => {
            if (mergedMap[newItem.Id]) {
              mergedMap[newItem.Id].quantity += 1;
            } else {
              mergedMap[newItem.Id] = { ...newItem, quantity: 1 };
            }
          });
          // selectedItemsData.comboSession[comboId?.itemId]["alternateItems"].push(...uniqueModifierGroups);
          selectedItemsData.comboSession[comboId?.itemId]["alternateItems"] = Object.values(mergedMap);
        }

        finalPayloadItems.push(newItem);
      }
    });

    selectedItemsData.comboSession[comboId?.itemId]["packageChildItems"].push(...finalPayloadItems);
    isClearingRef.current = true;
    setConcessionComboItem(null);
    setSelectedItems({});
    setConcessionData(selectedItemsData);
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    setConcessionComboItem([]);
  }, []);

  useEffect(() => {
    fetchComboItem(comboId)
  }, [comboId]);

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, [window]);

  window.addEventListener('resize', function () {
    setWindowSize(window.innerWidth);
  }, true);

  const onMaxNotify = useCallback(() => {
    const id = notify('warning', [
      'purchase.toasters.order_restriction_box_menu',
      { amount: maxQuantity }
      // { amount: 2 }
    ]);
  }, [maxQuantity]);

  useEffect(() => {
    if (isModalOpen) {
      if (windowSizes >= 992) {
        showBoxMenu();
      }
      else {
        setSummeDetails(!summeDetails);
        toggleExpand(!isExpanded)
      }
    }
  }, [isModalOpen, modal]);

  useEffect(() => {
    if (modal === false) {
      setIsModalOpen(!isModalOpen);
    }
  }, [modal]);

  useEffect(() => {
    if (isClearingRef.current) {
    isClearingRef.current = false;
    return;
  }
    if (isModalOpen && comboItemData?.length) {
      const items = comboItemData?.filter((item) => {
        return item?.alternateItems?.length === 0;
      });
      if (items?.length > 0) {
        items.forEach(item => handleDirectSelection(item));
      }
       const quantity = comboItemData?.length && comboItemData?.filter(item => item?.alternateItems?.length > 0)?.map((item) => {
        return item?.quantity
      })
      setMaxQuantity(Math?.max(...quantity));
    }
  }, [isModalOpen, comboItemData]);

  const quantity = selectedItemsData['comboSession'][comboId?.itemId]?.quantity;
  const priceInCents = (selectedItemsData['comboSession'][comboId?.itemId]?.priceInCents / 100).toFixed(2);
  const priceInCentsSet = priceInCents.replace('.', ',');
  const description = selectedItemsData['comboSession'][comboId?.itemId]?.description;
  const img = selectedItemsData['comboSession'][comboId?.itemId]?.imagePath;
  const comboItem = comboItemData?.length && comboItemData?.find(item => item.alternateItems && item.alternateItems.length > 0);
  const modifiersDescription = comboItem?.alternateItems || [];
  const itemWithModifiers = modifiersDescription.find(item =>
    item.ModifierGroups && item.ModifierGroups.length > 0
  );
  const modifiersData = itemWithModifiers?.ModifierGroups?.[0]?.Modifiers || [];
  return (
    <SectionEntities>
      <Container>
        {
          windowSize >= 992 ?
            (
              <div className='boxMenu_title'>
                {
                  comboItemData?.length > 0 &&
                  <Modal
                    isOpen={BoxMenu}
                    close={() => handleClearComboData(selectedItemsData, comboId?.itemId)}
                    title={t('common.box_menu_title')}
                    isBoxMenu={true}
                  // style={{ pointerEvents: 'none' }}
                  // shouldCloseOnOverlayClick={false}
                  >
                    <MainSection>
                      <SubSection>
                        <SubSection1>
                          <div className='image-section'>
                            <Image className="rewardImage" src={`${img}`} />
                          </div>
                          <div className='content-section'>
                            <div className='content-heading'>{description}</div>
                            {comboItemData?.length && comboItemData?.map((item, index) => (
                              <div className='content-subHeading'>
                                {/* <div>{quantity * item?.quantity} X {item?.[languageContents?.description]}</div> */}
                                <div>{quantity * item.quantity} X {item?.DescriptionTranslations
                                  ? item?.DescriptionTranslations.find(translation => translation.LanguageTag.split("-")[0] === language)?.Text || item.description
                                  : item?.description
                                }</div>
                              </div>
                            ))}
                            {showPfand && <div className='content-subHeading'>{itemWithModifiers?.ModifierGroups?.[0]?.MaximumQuantity} X {modifiersData[0]?.Description}</div>}
                          </div>
                        </SubSection1>
                        <SubSection2>
                          <div>
                            <div className='total-section'>
                              {/* <div className='boxMenu_inputField'>
                                <InputNumber
                                  min={1}
                                  value={quantity || 0}
                                  onChange={updateItemQuantity(selectedItemsData, comboId?.itemId)}
                                />
                              </div> */}
                              <div className='total-sub-section'>
                                <span className='sub-section1'>{quantity} X {currencyForCountry} {priceInCents}</span>
                                {showPfand && <span className='sub-section1'>{1} X {currencyForCountry} {modifiersData[0]?.PriceInCents / 100}</span>}
                                <span className='sub-section2'> {currencyForCountry} {showPfand ?
                                  ((quantity * priceInCents) + (1 * (modifiersData[0]?.PriceInCents / 100))).toFixed(2) :
                                  (quantity * priceInCents).toFixed(2)}</span>
                              </div>
                            </div>
                          </div>
                        </SubSection2>
                      </SubSection>
                    </MainSection>
                    <SelectionSelection>
                      {comboItemData?.length && comboItemData?.filter(item => item.alternateItems?.length > 0)?.map((item, index) => {
                        const totalSelectedQuantity = selectedItems[item.description]?.reduce((sum, selectedItem) => sum + selectedItem.quantity, 0) || 0;
                        return (
                          <>
                            <SelectionHeadingSelection key={item?.idx} style={{ marginTop: index === 0 ? "0px" : "24px" }}>
                              <div className='header-section'>
                                <div className='number-section'><span className='number-sub-section'>{index + 1}</span></div>
                                <span className='heading-content-section'>
                                  {/* <p className='heading-content-subSection1'>{item?.[languageContents?.description]}</p> */}
                                  <p className='heading-content-subSection1'>{item?.DescriptionTranslations
                                    ? item?.DescriptionTranslations.find(translation => translation.LanguageTag.split("-")[0] === language)?.Text || item.description
                                    : item?.description
                                  }</p>
                                  <p className='heading-content-subSection2'>max. {item.quantity}</p>
                                </span>
                              </div>
                            </SelectionHeadingSelection>
                            <SelectionItemSelection>
                              {item?.alternateItems?.length > 0 &&
                                item?.alternateItems.map((altItem, ind) => {
                                  const selectedQuantity = selectedItems[item.description]?.find(selectedItem => selectedItem.ItemId === altItem.Id)?.quantity || 0;
                                  const isDisabled = altItem?.SellingLimits?.IndefiniteLimit?.QuantityAvailable !== undefined &&
                                    altItem?.SellingLimits?.IndefiniteLimit?.QuantityAvailable <= 0;
                                  return (
                                    <Label
                                      // className="box-menu-radio"
                                      className={`box-menu-radio ${isDisabled ? 'disabled' : ''}`}
                                      style={{
                                        borderTop: ind === 0 && ('0px'),
                                        // cursor: 'pointer'
                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                        opacity: isDisabled ? 0.5 : 1
                                      }}
                                      key={altItem.Id}
                                    >
                                      {/* {altItem?.[languageContentsForPopup?.Description]} */}
                                      {altItem?.DescriptionTranslations
                                        ? altItem?.DescriptionTranslations.find(translation => translation.LanguageTag.split("-")[0] === language)?.Text || altItem.Description
                                        : altItem?.Description
                                      }
                                      {isDisabled &&
                                        <div className='notInStock'>
                                          <span>Sold Out</span>
                                        </div>}
                                      {item?.quantity === 1 ? (
                                        <Checkbox
                                          id={altItem.Id}
                                          checked={selectedItems[item.description]?.some(selectedItem => selectedItem.ItemId === altItem.Id) || false}
                                          onChange={() =>
                                            !isDisabled && handleCheckboxChange(item.id, item.description, altItem, item.quantity)}
                                          disabled={isDisabled}
                                        />
                                      )
                                        :
                                        <>
                                          <InputNumber
                                            value={selectedQuantity}
                                            max={item?.quantity}
                                            onChange={(value) => handleQuantityChange(item.id, item.description, altItem, value, item.quantity)}
                                            onMax={onMaxNotify}
                                            disabled={isDisabled || (totalSelectedQuantity >= item.quantity && selectedQuantity === 0)}
                                          />
                                        </>
                                      }
                                    </Label>
                                  )
                                })
                              }
                            </SelectionItemSelection >
                          </>
                        )
                      })
                      }
                    </SelectionSelection>

                    {/* Pfand Section (Only show if applicable) */}
                    {showPfand && (
                      <SelectionSelection>
                        {
                          selectedDrink?.length && selectedDrink?.map((item, index) => (
                            <div key={item?.Id}>
                              <SelectionHeadingSelection>
                                <div className="header-section">
                                  <div className="number-section">
                                    <span className="number-sub-section">2</span>
                                  </div>
                                  <span className="heading-content-section">
                                    <p className="heading-content-subSection1">{item?.Description}</p>
                                    <p className="heading-content-subSection2">min. {item?.MinimumQuantity}, max. {item?.MaximumQuantity}</p>
                                  </span>
                                </div>
                              </SelectionHeadingSelection>
                              <SelectionItemSelection>
                                {item?.Modifiers?.length > 0 && item?.Modifiers?.map((itemModifiers, index) => (
                                  <Label className="box-menu-radio">
                                    {itemModifiers?.Description} {(itemModifiers?.PriceInCents / 100).toFixed(2).replace(".", ",")} {currencyForCountry}
                                    <Checkbox id="pfand" checked={item?.MinimumQuantity === item?.MaximumQuantity} disabled />
                                  </Label>
                                ))
                                }
                              </SelectionItemSelection>
                            </div>
                          ))
                        }
                      </SelectionSelection>
                    )}
                    <ButtonSection isDisable={disableAddBtn}>
                      <div className='main-div'>
                        <div className='clear-btn'
                          onClick={() => handleClearComboData(selectedItemsData, comboId?.itemId)} tabIndex="0"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              e.currentTarget.click();
                            }
                          }}
                        >{t('common.box_menu_clear')}</div>
                        <div className='add-btn'
                          onClick={() => handleAddComboData()}
                          tabIndex={disableAddBtn ? -1 : 0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              if (!disableAddBtn) {
                                e.currentTarget.click();
                              }
                            }
                          }}
                        >{t('common.box_menu_add')}</div>
                      </div>
                    </ButtonSection>
                  </Modal>
                }
              </div>
            )
            :
            (
              <>
                {
                  summeDetails &&
                  <SelectionMobileBoxMenu className={isExpanded ? '_expanded' : ''}>
                    <div
                      className="b-selection-total-mob__mask"
                      aria-hidden
                    />
                    <div
                      className="b-selection-total-mob__info-wrapper"
                      aria-hidden
                      style={{
                        flexDirection: 'column'
                      }}
                    >
                      <MainSectionMobileView>
                        <div className='sub-menu'>
                          <p className='title'>{t('common.box_menu_title')}</p>
                          <span className='cross-img'><img src={CrossIcon} alt="crossIcon" onClick={() => handleSummeDetail(selectedItemsData, comboId?.itemId)} /></span>
                        </div>
                      </MainSectionMobileView>
                      <MainSection>
                        <SubSection>
                          <SubSection1>
                            <div className='image-section'>
                              <Image className="rewardImage" src={`${img}`} />
                            </div>
                            <div className='content-section'>
                              <div className='content-heading'>{description}</div>
                              {comboItemData?.length && comboItemData?.map((item, index) => (
                                <div className='content-subHeading'>
                                  {/* <div>{quantity * item.quantity} X {item?.[languageContents?.description]}</div> */}
                                  <div>{quantity * item.quantity} X {item?.DescriptionTranslations
                                    ? item?.DescriptionTranslations.find(translation => translation.LanguageTag.split("-")[0] === language)?.Text || item.description
                                    : item?.description
                                  }</div>
                                </div>
                              ))}
                              {showPfand && <div className='content-subHeading'>{itemWithModifiers?.ModifierGroups?.[0]?.MaximumQuantity} X {modifiersData[0]?.Description}</div>}
                            </div>
                          </SubSection1>
                        </SubSection>
                      </MainSection>
                      <SelectionSelection>
                        {comboItemData?.length && comboItemData?.filter(item => item.alternateItems?.length > 0)?.map((item, index) => {
                          const totalSelectedQuantity = selectedItems[item.description]?.reduce((sum, selectedItem) => sum + selectedItem.quantity, 0) || 0; return (
                            <>
                              <SelectionHeadingSelection key={item?.idx} style={{ marginTop: index === 0 ? "0px" : "24px" }}>
                                <div className='header-section'>
                                  <div className='number-section'><span className='number-sub-section'>{index + 1}</span></div>
                                  <span className='heading-content-section'>
                                    <p className='heading-content-subSection1'>{item?.[languageContents?.description]}</p>
                                    <p className='heading-content-subSection2'>max. {item.quantity}</p>
                                  </span>
                                </div>
                              </SelectionHeadingSelection>
                              <SelectionItemSelection>
                                {item?.alternateItems?.length > 0 &&
                                  item?.alternateItems.map((altItem, ind) => {
                                    const selectedQuantity = selectedItems[item.description]?.find(selectedItem => selectedItem.ItemId === altItem.Id)?.quantity || 0;
                                    const isDisabled = altItem?.SellingLimits?.IndefiniteLimit?.QuantityAvailable !== undefined &&
                                      altItem?.SellingLimits?.IndefiniteLimit?.QuantityAvailable <= 0;
                                    return (
                                      <Label
                                        // className="box-menu-radio"
                                        className={`box-menu-radio ${isDisabled ? 'disabled' : ''}`}
                                        style={{
                                          borderTop: ind === 0 && ('0px'),
                                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                                          opacity: isDisabled ? 0.5 : 1
                                        }}
                                        key={altItem.Id}
                                      >
                                        {/* {altItem?.[languageContentsForPopup?.Description]} */}
                                        {altItem?.DescriptionTranslations
                                          ? altItem?.DescriptionTranslations.find(translation => translation.LanguageTag.split("-")[0] === language)?.Text || altItem.Description
                                          : altItem?.Description
                                        }
                                        {isDisabled &&
                                          <div className='notInStock'>
                                            <span>Sold Out</span>
                                          </div>
                                        }
                                        {item?.quantity === 1 ? <Checkbox
                                          id={altItem.Id}
                                          checked={selectedItems[item.description]?.some(selectedItem => selectedItem.ItemId === altItem.Id) || false}
                                          onChange={() =>
                                            !isDisabled && handleCheckboxChange(item.id, item.description, altItem, item.quantity)}
                                          disabled={isDisabled}
                                        />
                                          :
                                          <>
                                            <InputNumber
                                              value={selectedQuantity}
                                              max={item?.quantity}
                                              onChange={(value) => handleQuantityChange(item.id, item.description, altItem, value, item.quantity)}
                                              onMax={onMaxNotify}
                                              disabled={isDisabled || totalSelectedQuantity >= item.quantity && selectedQuantity === 0}
                                            />
                                          </>
                                        }
                                      </Label>
                                    )
                                  })
                                }
                              </SelectionItemSelection >
                            </>
                          )
                        })
                        }
                      </SelectionSelection>

                      {showPfand && (
                        <SelectionSelection>
                          {
                            selectedDrink?.length && selectedDrink?.map((item, index) => (
                              <div key={item?.Id}>
                                <SelectionHeadingSelection>
                                  <div className="header-section">
                                    <div className="number-section">
                                      <span className="number-sub-section">2</span>
                                    </div>
                                    <span className="heading-content-section">
                                      <p className="heading-content-subSection1">{item?.Description}</p>
                                      <p className="heading-content-subSection2">min. {item?.MinimumQuantity}, max. {item?.MaximumQuantity}</p>
                                    </span>
                                  </div>
                                </SelectionHeadingSelection>
                                <SelectionItemSelection>
                                  {item?.Modifiers?.length > 0 && item?.Modifiers?.map((itemModifiers, index) => (
                                    <Label className="box-menu-radio">
                                      {itemModifiers?.Description} {(itemModifiers?.PriceInCents / 100).toFixed(2).replace(".", ",")} {currencyForCountry}
                                      <Checkbox id="pfand" checked={true} disabled />
                                    </Label>
                                  ))
                                  }
                                </SelectionItemSelection>
                              </div>
                            ))
                          }
                        </SelectionSelection>
                      )}
                      <div className='total-section-box-menu'>
                        <SubSection2>
                          <div>
                            {/* <div className='total-section-mobile-view'> */}
                            {/* <div className='boxMenu_inputField'>
                                <InputNumber
                                  min={1}
                                  value={quantity || 0}
                                  onChange={updateItemQuantity(selectedItemsData, comboId?.itemId)}
                                />
                              </div> */}
                            <div className='total-sub-section'>
                              <span className='sub-section1'>{quantity} X {currencyForCountry} {priceInCents}</span>
                              {showPfand && <span className='sub-section1'>{1} X {currencyForCountry} {modifiersData[0]?.PriceInCents / 100}</span>}
                              {/* <span className='sub-section2'>{currencyForCountry} {quantity * priceInCents}</span> */}
                              <span className='sub-section2'> {currencyForCountry} {showPfand ?
                                ((quantity * priceInCents) + (1 * (modifiersData[0]?.PriceInCents / 100))).toFixed(2) :
                                (quantity * priceInCents).toFixed(2)}</span>
                            </div>
                            {/* </div> */}
                          </div>
                        </SubSection2>
                        <SelectionSelection>
                          {/* <div className="total-sub-section">{renderSelectedItems()}</div>
                          {Object.keys(selectedItems)?.length > 0 && <div className="price-in-mobile-view"><strong>£ {calculateTotalPrice()}</strong></div>} */}
                        </SelectionSelection>
                        {/* Pfand Section (Only show if applicable) */}
                        <RowButton style={{
                          padding: '16px 20px'
                        }}>
                          <Button isPrimary
                            onClick={() => handleAddComboData()}
                            disabled={disableAddBtn}
                          >
                            {t('common.box_menu_add')}
                          </Button>
                        </RowButton>
                      </div>
                    </div>
                  </SelectionMobileBoxMenu>
                }
              </>
            )
        }
      </Container>
    </SectionEntities >
  )
}

export default BoxMenu;
